import { Component, Injector, Input } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import * as FileSaver from 'file-saver';
import { AnexoConsultaDto, ConsultaDto, ConsultaServiceProxy } from '@shared/service-proxies/service-proxies';
import { Subscription } from 'rxjs';

@Component({
  selector: 'anexos-consulta',
  templateUrl: './anexos-consulta.component.html',
  styleUrls: ['./anexos-consulta.component.scss']
})
export class AnexosConsultaComponent extends AppComponentBase {
  @Input() consulta: ConsultaDto;
  @Input() anexo: AnexoConsultaDto;
  private subscriptions: Subscription[] = [];

  constructor(
    injector: Injector,
    private readonly _consultaService: ConsultaServiceProxy,
  ) { super(injector) }

  download() {
    abp.ui.setBusy();
    const sub = this._consultaService.getTemporaryLink(this.anexo.arquivo.urlArquivo)
      .pipe(
        finalize(() => {
        })
      )
      .subscribe(async x => {
        await fetch(x).then(r => {
          r.blob().then(aux => {
            FileSaver.saveAs(aux, `${this.anexo.arquivo.nome}.${this.anexo.arquivo.extensaoArquivo}`);
            abp.ui.clearBusy();
          })
        });
      });
    this.subscriptions.push(sub);
  }
}
